/* eslint react/no-did-mount-set-state: off */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Transition } from 'react-transition-group';
import Link from 'gatsby-link';
import Card from '../Card/Card';
import './ProjectListing.scss';

const TRANSITION_FUNC = 'cubic-bezier(0.24, 0.64, 0.58, 1)';

class ProjectListing extends Component {
  static propTypes = {
    projectList: PropTypes.arrayOf(PropTypes.object).isRequired,
    layout: PropTypes.oneOf(['static', 'dynamic', 'fixed']),
    column: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    gutter: PropTypes.number,
    animation: PropTypes.oneOf(['fade', 'translate'])
  };

  static defaultProps = {
    layout: 'dynamic',
    column: 4,
    gutter: 12,
    animation: 'fade'
  };

  state = {
    projectPathPrefix: '',
    mounted: false
  };

  componentDidMount() {
    this.setState({ mounted: true });
    if (typeof window !== 'undefined') {
      /* eslint global-require: "off" */
      const lookupRequesterIp = require('../../shared/requesterIpLookupBehaviour');
      lookupRequesterIp().then(({ data }) => {
        if (data.status === 0) {
          this.setState({ projectPathPrefix: '/cn' });
        }
      });
    }
  }

  getLayout = projectList => {
    const { layout, column } = this.props;
    if (layout === 'static') {
      return projectList.map(project => {
        let className = 'col-1';
        switch (column) {
          case 1:
          case 2:
          case 4:
            className = `col-${4 / column}`;
            break;
          default:
            break;
        }
        return { ...project, className };
      });
    } else if (layout === 'fixed') {
      return projectList.map((project, index) => {
        const className = `col-${column[index % column.length]}`;
        return { ...project, className };
      });
    }
    return projectList.map(project => {
      const coverRatio = project.cover.childImageSharp.sizes.aspectRatio;
      let className = 'col-1';
      if (coverRatio > 2) {
        className = 'col-4';
      } else if (coverRatio === 2) {
        className = 'col-3';
      } else if (coverRatio < 2 && coverRatio > 1) {
        className = 'col-2';
      }
      return { ...project, className };
    });
  };

  render() {
    const { gutter, animation } = this.props;
    const { mounted } = this.state;
    const projectList = this.getLayout(this.props.projectList);
    const padding = gutter / 2;
    return (
      <div className="project-list" style={{ marginLeft: -padding, marginRight: -padding }}>
        {projectList.map((project, i) => {
          const delay = 40 * i;
          const duration = 1000;
          const timeout = delay + duration;
          const itemDefaultStyles = {
            transitionProperty: 'opacity, transform',
            transitionDuration: `${duration}ms, ${duration}ms`,
            transitionTimingFunction: `${TRANSITION_FUNC}, ${TRANSITION_FUNC}`,
            transitionDelay: `${delay}ms, ${delay}ms`
          };
          const itemTransitionStyles = {
            entering: {
              opacity: 0,
              transform: 'translateY(40%)'
            },
            entered: {
              opacity: 1,
              transform: 'translateY(0)'
            }
          };
          const parallaxDefaultStyles = {
            transitionProperty: 'transform',
            transitionDuration: `${duration}ms`,
            transitionTimingFunction: TRANSITION_FUNC,
            transitionDelay: `${delay}ms`
          };
          const parallaxTransitionStyles = {
            entering: {
              transform: 'translateY(-10%)'
            },
            entered: {
              transform: 'translateY(0)'
            }
          };
          return (
            <Transition key={project.title} in={mounted} timeout={timeout} mountOnEnter unmountOnExit>
              {state => (
                <Link
                  to={`${this.state.projectPathPrefix}/works${project.path}`}
                  className={classNames('project-item', project.className)}
                  style={{ ...itemDefaultStyles, ...itemTransitionStyles[state], padding }}
                >
                  <Card
                    animation={animation}
                    cover={project.cover}
                    color={project.color}
                    textTop={project.client}
                    textBottom={project.title}
                    style={{ ...parallaxDefaultStyles, ...parallaxTransitionStyles[state] }}
                  />
                </Link>
              )}
            </Transition>
          );
        })}
      </div>
    );
  }
}

export default ProjectListing;



// WEBPACK FOOTER //
// ./src/components/ProjectListing/ProjectListing.jsx